// import Vue from 'vue';
// import _ from 'lodash'

import { $http } from "@/utils/http";

import {
    SET_LIST_LENGTH,
    SET_LOADING_PRODUCTS_LIST,
    SET_PRODUCTS_LIST,
    SET_PRODUCTS_LIST_REQUEST,
    PRODUCTS_CHANGE_PAGE,
    SET_LOADING_FILTER_PRODUCTS_LIST,
    SET_FILTER_PRODUCTS_LIST,
    SET_FILTER_LIST_LENGTH,
    SET_LOADING_ALL_PRODUCTS_LIST,
    ACTIVE_CATEGORY,
    SET_CHILD_CATEGORY,
    SET_PARENT_CATEGORY,
    SET_MOBILE_CATEGORY,
    SET_FILTER_LIST_META,
} from "../mutation-types";

import {
    GET_PRODUCTS_LIST,
    GET_FILTER_PRODUCTS_LIST,
    GET_ALL_PRODUCTS_LIST,
    GET_ACTIVE_PRICE_FILTER,
    GET_CHILD_CATEGORY,
    GET_FILTER_PRODUCTS_LIST_ALL,
} from "../action-types";

const state = {
    smallerPrice: false,
    list: null,
    listRequest: null,
    listLoading: false,
    listLength: false,
    listFilter: null,
    listFilterLoading: false,
    listFilterLength: false,
    loadingAllProductList: false,
    skip: 0,
    count: 0,
    limit: 12,
    page: 1,
    activeCategory: "",
    childCategoryList: null,
    isOpenMobileCategory: false,
    stateParentCategory: "",
    listMeta: null,
};

const getters = {
    stateParentCategory: state => state.stateParentCategory,
    childCategoryList: state => state.childCategoryList,
    list: state => state.list,
    listRequest: state => state.listRequest,
    skip: state => state.skip,
    count: state => state.count,
    listLoading: state => state.listLoading,
    listLength: state => state.listLength,
    limit: state => state.limit,
    page: state => state.page,
    listFilter: state => state.listFilter,
    listMeta: state => state.listMeta,
    listFilterLoading: state => state.listFilterLoading,
    loadingAllProductList: state => state.loadingAllProductList,
    listFilterLength: state => state.listFilterLength,
    activeCategory: state => state.activeCategory,
    smallerPriceFilter: state => state.smallerPrice,
    mobileCategory: state => state.isOpenMobileCategory,
};

const actions = {
    [GET_CHILD_CATEGORY]: async ({ commit }, payload) => {
        // commit(SET_LOADING_PRODUCTS_LIST, true);
        try {
            const response = await $http.get(`v1/child-categories/${payload}`);
            commit(SET_CHILD_CATEGORY, response.data.data);
            return response.data;
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_LOADING_PRODUCTS_LIST, false);
        }
    },
    [GET_PRODUCTS_LIST]: async ({ commit }) => {
        commit(SET_LOADING_PRODUCTS_LIST, true);
        try {
            const response = await $http.get(`v1/products?per-page=${state.limit}&page=${state.page}`);
            commit(SET_PRODUCTS_LIST, response.data.data);
            commit(SET_PRODUCTS_LIST_REQUEST, response.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_PRODUCTS_LIST, false);
        }
    },
    [GET_FILTER_PRODUCTS_LIST]: async ({ commit }, payload) => {
        commit(SET_LOADING_FILTER_PRODUCTS_LIST, true);
        try {
            const response = await $http.post(
                `v1/catalog/get-products/${payload.categorySlug}?price[min]=${
                    payload.min ? payload.min : ""
                }&price[max]=${payload.max ? payload.max : ""}&per-page=${state.limit}&page=${state.page}&sort=${
                    payload.sort ? payload.sort : ""
                }`,
                payload.data
            );
            commit(SET_FILTER_PRODUCTS_LIST, response.data.data);
            commit(SET_FILTER_LIST_META, response.data.filter_meta);
            try {
                commit(SET_FILTER_LIST_LENGTH, response.data.meta.total);
            } catch (error) {}
            commit(SET_PARENT_CATEGORY, response.data);
            return response.data;
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_FILTER_PRODUCTS_LIST, false);
        }
    },
    [GET_FILTER_PRODUCTS_LIST_ALL]: async ({ commit }, payload) => {
        commit(SET_LOADING_FILTER_PRODUCTS_LIST, true);
        try {
            const response = await $http.post(
                `v1/catalog/get-products/${payload.categorySlug}?price[min]=${
                    payload.min ? payload.min : ""
                }&price[max]=${payload.max ? payload.max : ""}&per-page=1000&page=${state.page}&sort=${
                    payload.sort ? payload.sort : ""
                }`,
                payload.data
            );
            commit(SET_FILTER_PRODUCTS_LIST, response.data.data);
            try {
                commit(SET_FILTER_LIST_LENGTH, response.data.meta.total);
            }catch (error) {}
            commit(SET_PARENT_CATEGORY, response.data);
            return response.data;
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_FILTER_PRODUCTS_LIST, false);
        }
    },
    [GET_ALL_PRODUCTS_LIST]: async ({ commit }, payload) => {
        commit(SET_LOADING_ALL_PRODUCTS_LIST, true);
        try {
            const response = await $http.post(
                `v1/catalog/get-products?per-page=${state.limit}&page=${state.page}`,
                payload
            );
            commit(SET_FILTER_PRODUCTS_LIST, response.data.data);
            try {
                commit(SET_FILTER_LIST_LENGTH, response.data.meta.total);
            }catch (error) {}
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_ALL_PRODUCTS_LIST, false);
        }
    },
};

const mutations = {
    [SET_PARENT_CATEGORY](state, data) {
        state.stateParentCategory = data;
    },
    [GET_ACTIVE_PRICE_FILTER]() {
        state.smallerPrice = true;
    },
    [SET_MOBILE_CATEGORY]() {
        state.isOpenMobileCategory = true;
    },
    [SET_PRODUCTS_LIST](state, list) {
        state.list = list;
    },
    [SET_PRODUCTS_LIST_REQUEST](state, payload) {
        state.listRequest = payload;
    },
    [SET_LOADING_PRODUCTS_LIST](state, status) {
        state.listLoading = status;
    },
    [SET_LIST_LENGTH](state, data) {
        state.listLength = data;
    },
    [PRODUCTS_CHANGE_PAGE](state, page) {
        state.page = page;
    },
    [SET_FILTER_PRODUCTS_LIST](state, list) {
        state.listFilter = list;
    },
    [SET_LOADING_FILTER_PRODUCTS_LIST](state, status) {
        state.listFilterLoading = status;
    },
    [SET_LOADING_ALL_PRODUCTS_LIST](state, status) {
        state.loadingAllProductList = status;
    },
    [SET_FILTER_LIST_LENGTH](state, data) {
        state.listFilterLength = data;
    },
    [ACTIVE_CATEGORY](state, activeCategory) {
        state.activeCategory = activeCategory;
    },
    [SET_CHILD_CATEGORY](state, list) {
        state.childCategoryList = list;
    },
    [SET_FILTER_LIST_META](state, list) {
        state.listMeta = list;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
